import React from 'react';
import Uganda1_kindergarten_subjects from './uganda1_kindergarten_subjects';

const Uganda1_kindergarten = () => {
  return (
    <div>
     <Uganda1_kindergarten_subjects /> 
    </div>
  );
}

export default Uganda1_kindergarten;
